export const arePojoSendersEqual = (sender1, sender2) => {
  if (!sender1 || !sender2) return false;
  const sender1Ids = `${sender1.actorId || ''} ${JSON.stringify(sender1.deliveryIdentifier || '')} ${sender1.name || ''}`;
  const sender2Ids = `${sender2.actorId || ''} ${JSON.stringify(sender2.deliveryIdentifier || '')} ${sender2.name || ''}`;
  if (sender1Ids === sender2Ids) return true;
  return false;
};